import type { ReactNode } from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { ValueDto } from '@/services/ws-search/src/main/resources/rest-api';
import { Typography } from '@/js/libs/ui';

import { SearchListItem } from './SearchListItem';
import { BlockTitleWrapper, BlockWrapper, ShowMoreWrapper } from './styles';

type Props = {
  title: string;
  total: number;
  icon: ReactNode;
  items: ValueDto[];
  search: string;
  onItemClick: (id: ValueDto['id']) => void;
  onShowMoreClick: () => void;
  highlightColor: string;
  dataTestId?: string;
};

export const SearchListBlock = memo(function SearchListBlock({
  icon,
  items,
  title,
  total,
  onItemClick,
  onShowMoreClick,
  search,
  highlightColor,
  dataTestId,
}: Props) {
  const [t] = useTranslation(['backend', 'common']);

  return (
    <BlockWrapper data-testid={dataTestId}>
      <BlockTitleWrapper>
        {icon}
        <Typography.TextMedium>
          {title} ({total})
        </Typography.TextMedium>
      </BlockTitleWrapper>
      {items.map((v) => (
        <SearchListItem
          key={v.id}
          item={v}
          search={search}
          onClick={onItemClick}
          highlightColor={highlightColor}
          dataTestId='global-search-item'
        />
      ))}
      {total > 10 && (
        <ShowMoreWrapper data-testid='show-all-button'>
          <a onClick={onShowMoreClick}>{t('common:SHOW_ALL')}</a>
        </ShowMoreWrapper>
      )}
    </BlockWrapper>
  );
});
